import { render, staticRenderFns } from "./activity-type.vue?vue&type=template&id=323906ea&scoped=true&"
import script from "./activity-type.vue?vue&type=script&lang=js&"
export * from "./activity-type.vue?vue&type=script&lang=js&"
import style0 from "./activity-type.vue?vue&type=style&index=0&id=323906ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323906ea",
  null
  
)

export default component.exports